function print_monthly_chart(){
  var data = document.getElementById('graph_data').innerHTML;
  var chart_title = $("#monthly_chart").data("chart-title");
  $("#monthly_chart").highcharts({
    title: {
      align: "center",
      text: chart_title,
      style: {
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        fontSize: "10pt",
        fontWeight: "700",
        textTransform: "uppercase",
        letterSpacing: "0.18em",
        color: "#111"
      }
    },

    yAxis: {
      min: 0,
      title: {
        text: 'Patients'
      }
    },

    data: {
      csv: data
    },

    series: [{
      type: "column",
      dataLabels:{
        enabled: true
      }
    }]
  });
}

function print_yearly_chart(){
  var data = document.getElementById('graph_data').innerHTML;
  var chart_title = $("#monthly_chart").data("chart-title");

  $("#yearly_chart").highcharts({
    title: {
      align: "center",
      text: chart_title,
      style: {
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        fontSize: "10pt",
        fontWeight: "700",
        textTransform: "uppercase",
        letterSpacing: "0.18em",
        color: "#111"
      }
    },

    yAxis: {
      min: 0,
      title: {
        text: 'Consults'
      }
    },

    data: {
      csv: data
    },

    series: [{
      type: "column",
      dataLabels:{
        enabled: true
      }
    },{
      type: "column",
      dataLabels:{
        enabled: true
      }
    }]
  });
}

var printable_ready = $(function(){
  if(!$(".Printables").length && !$(".Print-page").length) return;
  if($("#yearly_chart").length){
    print_yearly_chart();
    return;
  }
  if($("#monthly_chart").length){
    print_monthly_chart();
    return;
  }
});

$(document).ready(printable_ready);
$(document).on('page:load', printable_ready);
